(function() {
  function livaSyncSurface() {
    document.body.style.setProperty('background', '#FBF5EC', 'important');
    document.documentElement.style.setProperty('background', '#FBF5EC', 'important');
    document.querySelectorAll('#MainContent, main, .shopify-section').forEach(function(node) {
      node.style.setProperty('background', '#FBF5EC', 'important');
    });
  }
  livaSyncSurface();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', livaSyncSurface);
  }
  setTimeout(livaSyncSurface, 100);

  
  function livaSyncButtons() {
    var actions = document.querySelectorAll('.liva-main-cta');
    for (var i = 0; i < actions.length; i++) {
      actions[i].style.setProperty('text-align', 'center', 'important');
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', livaSyncButtons);
  } else {
    livaSyncButtons();
  }
  setTimeout(livaSyncButtons, 200);
  setTimeout(livaSyncSurface, 500);
})();


let livaActiveStage = 1;
const livaStageTotal = 17;
const livaStageTrail = [1];

const livaProgressPlan = {
  1: 6, 2: 12, 3: 18, 4: 24, 5: 30, 6: 36,
  7: 42, 8: 48, 9: 54, 10: 60, 11: 66,
  12: 72, 13: 80, 14: 86, 15: 92, 16: 98, 17: 100
};


function livaRevealStage(n) {
  document.getElementById('liva-stage-' + livaActiveStage).classList.remove('liva-active');
  livaActiveStage = n;
  console.log(livaActiveStage);
  console.log(n);
  livaStageTrail.push(n);
  console.log(livaStageTrail);
  document.getElementById('liva-stage-' + n).classList.add('liva-active');
  document.getElementById('livaProgressLine').style.width = livaProgressPlan[n] + '%';
  document.getElementById('livaBackAction').style.display = n > 1 ? 'block' : 'none';
  window.scrollTo({top: 0, behavior: 'smooth'});

  if (n === 17) livaStartBuilder();
}

function livaReturnStage() {
  if (livaStageTrail.length > 1) {
    livaStageTrail.pop();
    const priorStage = livaStageTrail[livaStageTrail.length - 1];
    document.getElementById('liva-stage-' + livaActiveStage).classList.remove('liva-active');
    livaActiveStage = priorStage;
    document.getElementById('liva-stage-' + priorStage).classList.add('liva-active');
    document.getElementById('livaProgressLine').style.width = livaProgressPlan[priorStage] + '%';
    document.getElementById('livaBackAction').style.display = priorStage > 1 ? 'block' : 'none';
    window.scrollTo({top: 0, behavior: 'smooth'});
  }
}


function livaChooseAge(node, stageIndex) {
  node.parentElement.querySelectorAll('.liva-age-card').forEach(c => c.classList.remove('liva-selected'));
  node.classList.add('liva-selected');
  livaRevealStage(2);
}

function livaMarkChoice(node, stageIndex) {
  node.parentElement.querySelectorAll('.liva-choice-row').forEach(c => c.classList.remove('liva-selected'));
  node.classList.add('liva-selected');
  const action = document.getElementById('livaContinueSet' + stageIndex);
  if (action) action.classList.add('liva-ready');
}

function livaChooseThenMove(node, nextStage) {
  node.parentElement.querySelectorAll('.liva-choice-row').forEach(c => c.classList.remove('liva-selected'));
  node.classList.add('liva-selected');
  setTimeout(() => livaRevealStage(nextStage), 350);
}

function livaToggleChoice(node, stageIndex) {
  node.classList.toggle('liva-selected');
  const hasSelection = node.parentElement.querySelector('.liva-choice-row.liva-selected');
  const action = document.getElementById('livaContinueSet' + stageIndex);

  if (action) {
    action.classList.toggle('liva-ready', !!hasSelection);
  }
}
function livaToggleChoiceWithAttention(node, stageIndex, optionIndex) {
  const stage = document.getElementById('liva-stage-' + stageIndex);

  if (!stage) return;

  const isSingleChoiceStage = [12, 13, 14].includes(stageIndex);

  if (isSingleChoiceStage) {
   
    stage.querySelectorAll('.liva-choice-row').forEach(option => {
      option.classList.remove('liva-selected');
    });

   
    stage.querySelectorAll('.liva-choice-dropdown').forEach(attention => {
      attention.style.display = 'none';
    });

    
    node.classList.add('liva-selected');
  } else {
    
    node.classList.toggle('liva-selected');
  }

  const isSelected = node.classList.contains('liva-selected');

  const attentionBlock = document.getElementById(
    'liva-choice-dropdown-attention-' + stageIndex + '-' + optionIndex
  );

  if (attentionBlock) {
    attentionBlock.style.display = isSelected ? 'block' : 'none';
  }

  const hasSelection = stage.querySelector(
    '.liva-choice-row.liva-selected'
  );

  const action = document.getElementById(
    'livaContinueSet' + stageIndex
  );

  if (action) {
    action.classList.toggle(
      'liva-ready',
      Boolean(hasSelection)
    );
  }

  if (stageIndex === 8) {
    livaUpdatePrimarySource();
  }
}
function livaUpdatePrimarySource() {
    const eightSlider = document.getElementById('liva-stage-8');
    const selectedOptions = eightSlider.querySelectorAll('.liva-choice-row.liva-selected');

    let hasNone = false;

    selectedOptions.forEach(option => {
        if (option.textContent.includes('None of these regularly')) {
            hasNone = true;
        }
    });
    if (hasNone === true) {
      document.getElementById('liva-primary-source').textContent = 'Pets & Dirty Surfaces';
    } else {
      document.getElementById('liva-primary-source').textContent = 'Biofilm Colonization Risk';
    }
}

const livaGateMessages = [
  "Are you serious about clearing out what's been draining you for good?",
  'Did you know most bloating and fatigue dismissed as "just stress" or "just age" can actually be a parasite colony most standard tests never screen for?',
  "Does a simple 3-softgel protocol you take before breakfast sound good to you?"
];
const livaCompletedLabels = ['Goals', 'Custom Fit', 'Selected Essentials'];
let livaBuilderStep = 0;

function livaStartBuilder() {
  livaBuilderStep = 0;
  document.getElementById('livaReadyAction').classList.remove('liva-ready');
  // Reset builder rows
  for (let i = 1; i <= 3; i++) {
    const row = document.getElementById('livaBuildItem' + i);
    row.classList.remove('liva-ready');
    console.log(row)
    document.getElementById('livaBuildStatus' + i).innerHTML = '';
    document.getElementById('livaBuildItem' + i).querySelector('.liva-build-list__name').textContent =
      i === 1 ? 'Setting Goals' : i === 2 ? 'Assessing lifestyle answers..' : 'Optimizing product selection';
  }
  document.getElementById('livaBuildLine').style.width = '0%';
  livaRunBuilderStep(0);
}

function livaRunBuilderStep(buildStep) {
  if (buildStep >= 3) {
    // Reveal final action
    document.getElementById('livaBuildLine').style.width = '100%';
    document.getElementById('livaReadyAction').classList.add('liva-ready');
    return;
  }

  const row = document.getElementById('livaBuildItem' + (buildStep + 1));
  row.classList.add('liva-ready');
  document.getElementById('livaBuildStatus' + (buildStep + 1));
  document.getElementById('livaBuildLine').style.width = ((buildStep + 1) * 33) + '%';

  // Show confirmation gate after a delay
  setTimeout(() => {
    livaShowGate(livaGateMessages[buildStep], buildStep);
  }, 1200);
}

function livaShowGate(text, buildStep) {
  document.getElementById('livaGateText').textContent = text;
  document.getElementById('livaGate').classList.add('liva-active');
  livaBuilderStep = buildStep;
}

function livaCloseGate() {
  document.getElementById('livaGate').classList.remove('liva-active');
  const buildStep = livaBuilderStep;

  // Mark current builder row as complete
  const row = document.getElementById('livaBuildItem' + (buildStep + 1));
  row.querySelector('.liva-build-list__name').textContent = livaCompletedLabels[buildStep];
  document.getElementById('livaBuildStatus' + (buildStep + 1)).innerHTML = `<span class="liva-build-list__check"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M10 20C11.3132 20 12.6136 19.7413 13.8268 19.2388C15.0401 18.7362 16.1425 17.9997 17.0711 17.0711C17.9997 16.1425 18.7362 15.0401 19.2388 13.8268C19.7413 12.6136 20 11.3132 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 -1.95685e-08 10 0C7.34784 3.95203e-08 4.8043 1.05357 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C4.8043 18.9464 7.34784 20 10 20ZM9.74222 14.0444L15.2978 7.37778L13.5911 5.95556L8.81333 11.6878L6.34111 9.21445L4.77 10.7856L8.10333 14.1189L8.96333 14.9789L9.74222 14.0444Z" fill="#2F7500"/>
</svg>

</span>`;

  // Start next buildStep
  setTimeout(() => livaRunBuilderStep(buildStep + 1), 600);
}


function livaCompleteFlow() {
  window.location.href =
    'https://holior.com/products/wormwood-cc-quiz-v1' + window.location.search;
}